import {
    idbGetData,
    idbPutData,
    idbDeleteData
} from "./indexDB.service";

const DRAFT_KEY = "POS_DRAFT";

export const savePosDraft = async (data) => {
    try {
        await idbPutData("posDraft", {
            _id: DRAFT_KEY,
            ...data,
            updatedAt: Date.now(),
        });
    } catch (e) {
        console.error("Save draft failed", e);
    }
};

export const getPosDraft = async () => {
    try {
        const res = await idbGetData("posDraft", DRAFT_KEY);
        if (!res || !res.data || Array.isArray(res.data) || res.data._id !== DRAFT_KEY) {
            return null;
        }
        return res.data;
    } catch {
        return null;
    }
};

export const clearPosDraft = async () => {
    try {
        await idbDeleteData("posDraft", DRAFT_KEY);
    } catch { }
};
